import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-legend-play",
  "use": "icon-legend-play-usage",
  "viewBox": "0 0 25 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 25 24\" id=\"icon-legend-play\"><rect x=\".352\" width=\"24\" height=\"24\" rx=\"12\" fill=\"#4066D4\" /><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M9.354 7.333A.667.667 0 0 0 8.688 8v8c0 .368.298.667.666.667h1.334a.667.667 0 0 0 .666-.667V8a.667.667 0 0 0-.666-.667H9.354Zm4.667 0a.667.667 0 0 0-.667.667v8c0 .368.299.667.667.667h1.333a.667.667 0 0 0 .667-.667V8a.667.667 0 0 0-.667-.667h-1.333Z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol